import React, { FC } from 'react';
import styled from 'styled-components';

import EmbedModal, { ModalSize, Close } from 'src/presentation/components/pages/shared/EmbedModal';
import ExternalLink from 'src/presentation/components/pages/shared/ExternalLink';
import { getAdminURL } from 'src/presentation/components/pages/shared/utils/Utils';
import { CHAT_BRAND } from 'src/constants/branding';

type GoToChannelPageNotificationModalProps = {
  name: string;
  onCancel: Function;
};

const GoToChannelPageNotificationModal: FC<GoToChannelPageNotificationModalProps> = ({ name, onCancel }) => {
  const title = 'Set up Entry Points';
  const content = <EntryPoints name={name} />;

  return <StyledEmbedModal title={title} content={content} onCancel={onCancel} modalSize={ModalSize.LARGE} />;
};

const EntryPoints = ({ name }) => (
  <DescriptionContainer>
    {name} was successfully configured. <br />
    <ExternalLink
      data-aid="chat-modal-success-goToChannels"
      label="Go to Entry Points"
      to={getAdminURL('entry-points')}
    />{' '}
    to confirm this {CHAT_BRAND.name} is linked to the correct Inbox.
  </DescriptionContainer>
);

const DescriptionContainer = styled.div`
  line-height: 162%;
  text-align: center;
`;

const StyledEmbedModal = styled(EmbedModal)`
  .Modal-backdrop {
    background-color: ${p => p.theme.colors.white};
    opacity: 0.8;
  }

  .modalCard-content {
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.04), 0px 0px 10px rgba(0, 0, 0, 0.06), 0px 0px 80px rgba(0, 0, 0, 0.06);
    padding: 18px 45px;

    ${Close} {
      height: 0;
    }
  }
`;

export default GoToChannelPageNotificationModal;
